import { AxiosRequestConfig } from "axios";
import { getInstance } from "../../core/axios-gateway";
import { TRestListData, TRestListParams } from "../../types/rest";
import { TCommercial, TSupplierRole } from "../../types/commercial";

const BASE_PATH = "/api/suppliers";

// All supplier-user (commercial) mutations flow through the backoffice-only
// `/admin/users` group: the supplier id travels as a `supplierId` query param
// and the proxy injects `X-User-Roles: ADMIN`. The portal-only routes that
// require `x-supplier-id` cannot be reached from backoffice — that header is
// stripped on admin sessions.

const ADMIN_USERS_PATH = `${BASE_PATH}/admin/users`;

const requireSupplierId = (supplierId: string | undefined | null): string => {
  if (!supplierId) {
    throw new Error(
      "supplierId es obligatorio para operar sobre usuarios del proveedor"
    );
  }
  return supplierId;
};

export const getUsersBySupplierId = async (
  supplierId: string,
  params: TRestListParams = {}
) => {
  return getInstance()
    .get<TRestListData<TCommercial>>(ADMIN_USERS_PATH, {
      params: { ...params, supplierId: requireSupplierId(supplierId) },
    })
    .then((res) => res.data);
};

export const getUserById = async (
  userId: string,
  supplierId?: string,
  config?: AxiosRequestConfig
) => {
  return getInstance()
    .get<TCommercial>(`${ADMIN_USERS_PATH}/${userId}`, {
      ...(config ?? {}),
      params: {
        ...(config?.params ?? {}),
        supplierId: requireSupplierId(supplierId),
      },
    })
    .then((res) => res.data);
};

export const createUser = async (data: Partial<TCommercial>) => {
  return getInstance()
    .post<TCommercial>(ADMIN_USERS_PATH, data, {
      params: { supplierId: requireSupplierId(data.supplierId) },
    })
    .then((res) => res.data);
};

export const updateUser = async (
  userId: string,
  data: Partial<TCommercial>
) => {
  return getInstance()
    .put<TCommercial>(`${ADMIN_USERS_PATH}/${userId}`, data, {
      params: { supplierId: requireSupplierId(data.supplierId) },
    })
    .then((res) => res.data);
};

export const deleteUser = async (userId: string, supplierId: string) => {
  return getInstance()
    .delete(`${ADMIN_USERS_PATH}/${userId}`, {
      params: { supplierId: requireSupplierId(supplierId) },
    })
    .then((res) => res.data);
};

export const getSupplierRoles = async (
  supplierId: string,
  params: TRestListParams = {}
) => {
  return getInstance()
    .get<TRestListData<TSupplierRole>>(`${BASE_PATH}/${supplierId}/roles`, {
      params,
    })
    .then((res) => res.data);
};
